module.exports = __webpack_public_path__ + "static/img/iphone_msptitle1.27fc119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msptitle1.png
// module id = xgPi
// module chunks = 0